'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getIsDebugMode() {
  return _enviro2.default.debug('event-tracking-tools');
}

exports.default = getIsDebugMode;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/utils/getIsDebugMode.js
// module id = 437
// module chunks = 0